import { l } from '../../lib/imports'
import { rando } from '../../lib/rando-sidecar'
import { chessGameManager } from './chessGameManager-sidecar'
import { chessGameRules } from './chessGameRules-sidecar'
import { EChessTeam } from './chessPieces'
import { chessPieces } from './chessPieces-sidecar'
import { EChessPieceType } from './chessPiecesData'
import { chessMessagePieceKill } from './messages/chessMessagePieceKill-sidecar'
import { chessWebsockets } from './messages/chessWebsockets-sidecar'

const namespace = 'chess-handicap-board'

export function* generator_handicap(): Generator<number, number, number> {
  console.log(namespace, 'handicap board')

  if (chessWebsockets.getIsHost()) {
    let handicap = chessGameManager.get().handicap

    let team = EChessTeam.White
    if (handicap < 0) {
      handicap = -handicap
      team = EChessTeam.Black
    }
    let pieces = l.filter(
      chessPieces.getAll(),
      (c) =>
        c.team === team && !c.isDead && c.data.type !== EChessPieceType.King,
    )

    let tries = 0
    if (handicap > 0) {
      yield chessGameRules.get().handicapDelay
      while (handicap > 0 && pieces.length > 0 && tries < 1000) {
        tries++

        let p = rando.sample(pieces)

        if (p.data.pointCost <= handicap + 1) {
          l.remove(pieces, p)
          handicap -= p.data.pointCost
          chessMessagePieceKill.sendMessageAndImmediatelyExecute({
            pieceId: p.id,
          })
          yield chessGameRules.get().handicapDelay
        }
      }
    }
  }

  return 0
}
